'use client';

import Link from 'next/link';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@/components/ui/dialog';

interface SuccessModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function SuccessModal({
  open,
  onOpenChange,
}: SuccessModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {/* w-full do DialogContent encosta nas duas bordas em 390px. */}
      <DialogContent className="w-[calc(100%-2rem)] sm:w-full sm:max-w-lg flex flex-col gap-5 p-8 text-left sm:p-10">
        <CheckCircle2
          className="h-14 w-14 text-bluecaixa"
          strokeWidth={1.5}
          aria-hidden="true"
        />

        <DialogTitle className="text-2xl font-extrabold leading-tight tracking-normal text-bluecaixa sm:text-3xl">
          Tudo certo! Recebemos sua solicitação.
        </DialogTitle>

        {/* DialogDescription renderiza um <p>; asChild evita <p> dentro de <p>. */}
        <DialogDescription asChild>
          <div className="flex flex-col gap-4 text-sm text-[#525252] sm:text-base">
            <p>Agradecemos seu interesse nos produtos CAIXA Pré-Pagos.</p>
            <p>
              Mantenha seu celular por perto! Em breve,{' '}
              <strong className="font-semibold text-[#3b3d40]">
                um especialista entrará em contato
              </strong>{' '}
              para dar os próximos passos.
            </p>
            <p>Enquanto isso, conheça nossos outros produtos.</p>
          </div>
        </DialogDescription>

        <Link
          href="/"
          className="mt-1 flex w-full items-center justify-center gap-2 rounded-2xl bg-orangecaixa py-4 font-semibold text-white transition-colors hover:bg-orangecaixa/90"
        >
          Conhecer produtos
          <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </DialogContent>
    </Dialog>
  );
}
